'use client'

import styles from './NewsletterSignUpSection.module.scss'
import Image from 'next/image'

type ExpectationItem = {
  title?: string;
  description?: string;
  icon?: {
    asset: {
      url: string;
      metadata: {
        dimensions: {
          width: number;
          height: number;
        }
      }
    }
  }
}

type WhatToExpectProps = {
  expectationItems?: ExpectationItem[];
}

const WhatToExpect = ({ expectationItems }: WhatToExpectProps) => {
  if (!expectationItems || expectationItems.length === 0) {
    return null
  }

  return (
    <div className={styles.whatToExpectWrapper}>
      <h3 className={styles.eyebrow}>WHAT TO EXPECT</h3>
      <div className={styles.whatToExpectContent}>
        <div className={styles.expectationItems}>
          {expectationItems.map((item, index) => (
            <div key={index} className={styles.expectationItem}>
              <div className={styles.expectationIcon}>
                {item.icon && (
                  <Image
                    src={item.icon.asset.url}
                    alt={item.title || ''}
                    width={item.icon.asset.metadata.dimensions.width}
                    height={item.icon.asset.metadata.dimensions.height}
                  />
                )}
              </div>
              <div className={styles.expectationContent}>
                {item.title && <h4 className={styles.expectationTitle}>{item.title}</h4>}
                {item.description && <p className={styles.expectationDescription}>{item.description}</p>}

                {index < expectationItems.length - 1 && <div className={styles.divider}></div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WhatToExpect
